import { Outlet } from 'react-router';
import { DarkModeProvider } from '../context/DarkModeContext';
import { AuthProvider, useAuth } from '../context/AuthContext';
import { SubscriptionProvider } from '../context/SubscriptionContext';
import { VersionProvider } from '../context/VersionContext';
import { UpdateToast } from './UpdateToast';

function DarkModeWrapper({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  return (
    <DarkModeProvider userId={user?.id ?? null}>
      {children}
    </DarkModeProvider>
  );
}

export function RootLayout() {
  return (
    <AuthProvider>
      <SubscriptionProvider>
        <DarkModeWrapper>
          {/* Versions-Check umschließt ALLE Seiten (auch Kunden-Links wie /unterschreiben),
              damit der Update-Hinweis überall erscheint. */}
          <VersionProvider>
            <Outlet />
            <UpdateToast />
          </VersionProvider>
        </DarkModeWrapper>
      </SubscriptionProvider>
    </AuthProvider>
  );
}
